/**
 * @vuepress
 * ---
 * title: asigned transformer
 */

import Transformer from '../transformer'

class assignTransformer extends Transformer {
  static fetch(payload) {
    return {
      'promiseDate': payload.promise_date
    }
  }
  static send(payload) {
    return {
        'promise_date': payload.promiseDate
      }
  }
}
export default assignTransformer
